/* eslint-disable react/jsx-boolean-value */
import React, { useState } from 'react';
import Input from '../Form/input';
import { Container } from './styles';

type ButtonProps = {
  title?: string;
  customState?: any;
  setCustomState?: any;
  isTrue?: boolean;
  name: string;
};

SwitchButton.defaultProps = {
  title: '',
  isTrue: false,
  customState: false,
  setCustomState: false,
};

export default function SwitchButton({
  customState,
  setCustomState,
  isTrue,
  title,
  name,
}: ButtonProps) {
  const [isActive, setIsActive] = useState(isTrue);

  return (
    <Container>
      <button
        type="button"
        className={isActive ? 'active' : ''}
        onClick={() => setIsActive(!isActive)}
      >
        <span />
      </button>
      <Input type="checkbox" value={isActive ? 'true' : 'false'} name={name} />
      <h6> {title}</h6>
    </Container>
  );
}
